export const OnboardingWelcome = () => null
